import type { UnitCircleWidgetConfig } from '../unit-circle.model';

/** Axis markers in radians without special angle labels — focuses on the 4 cardinal radian values. */
export const UNIT_CIRCLE_AXIS_RADIANS_PRESET: UnitCircleWidgetConfig = {
  id: 'unit-circle-axis-radians',
  type: 'unit-circle',
  params: {
    point: { angle: '\\pi/4', snap: 'attract' },
    axisMarkers: 'radians',
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -2, xEnd: 2, yStart: -2, yEnd: 2 },
      grid: { type: 'lines', visible: true },
    },
  },
};
